import { useEffect, useState } from "react";
import { Menu } from "../../components/menu/menu";
import { bemCN } from "../../config/bem-classname";
import "./feedback-page.scss";
import { MessageRequestDTO } from "../../api/Api";
import { Input, TypeDataInput, TypeViewInput } from "../../ui/input/input";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { feedbackService } from "../../services/feedback-service";
import { Modal } from "../../ui/modal/modal";
import { text10HasError, text3HasError } from "../../utils/validation-input";

const feedbackPageCn = bemCN("feedback-page");

export const FeedbackPage = () => {
  const [feedback, setFeedback] = useState<MessageRequestDTO>({
    subject: "",
    message: "",
  });
  const [isShowModal, setIsShowModal] = useState(false);

  const [isDisableButton, setIsDisableButton] = useState(false);
  const onClickFeedback = () => {
    feedbackService.sendFeedback(feedback).then((res: number) => {
      if (res == 200) {
        setFeedback({ subject: "", message: "" });
        setIsShowModal(true);
      }
    });
  };

  useEffect(() => {
    if (!text3HasError(feedback.subject) && !text10HasError(feedback.message)) {
      setIsDisableButton(true);
    } else {
      setIsDisableButton(false);
    }
  }, [feedback]);

  return (
    <div className={feedbackPageCn()}>
      <Menu title="Связаться с нами" />
      <div>
        <Input
          onChange={(v: string) => setFeedback({ ...feedback, subject: v })}
          value={feedback.subject}
          typeData={TypeDataInput.text}
          typeView={TypeViewInput.text}
          placeholder="Тема письма"
          isValidate
          validateFunc={text3HasError}
        />
        <Input
          onChange={(v: string) => setFeedback({ ...feedback, message: v })}
          value={feedback.message}
          typeData={TypeDataInput.text}
          typeView={TypeViewInput.longText}
          placeholder="Напишите нам"
          isValidate
          validateFunc={text10HasError}
        />
        <Button
          text="Отправить"
          color={ButtonColors.green}
          size={ButtonSizes.big}
          onClick={onClickFeedback}
          noDisabled={!isDisableButton}
        />
      </div>
      <Modal
        id="successSendModal"
        isShowDialog={isShowModal}
        setIsShowDialog={setIsShowModal}
      >
        <div className={feedbackPageCn("modal")}>
          <p>Сообщение успешно отправлено!</p>
          <Button
            onClick={() => setIsShowModal(false)}
            color={ButtonColors.crimson}
            size={ButtonSizes.big}
            text="Ок"
          />
        </div>
      </Modal>
    </div>
  );
};
